// ----------------------------------------------------
// Tags
// ----------------------------------------------------

export const TAGS = {
  0: 'Praha',
  1: 'Brno',
  2: 'Plzeň',
  3: 'Liberec',
  4: 'Karlovy Vary',
  5: 'Ústí nad Labem',
  6: 'Teplice',
  7: 'Prostějov',
  8: 'Cínovec',
  9: 'České Budějovice',

  100: 'Neznámá místa',
  101: 'Zranění a zavraždění',
  102: 'Tisk a rozhlas',
  103: 'ČS armáda',
  104: 'Pravděpodobní autoři záběrů',
};

// ----------------------------------------------------
// Texts
// ----------------------------------------------------

export const TEXT = {
  PROJECT_INFO_TITLE: 'O projektu',
  EMPTY_CATEGORY: 'Kategorie je prázdná',
  VIDEOS: 'Videa',
  PHOTOS: 'Fotky',
  PHOTO: 'Fotografie',
  VIDEO: 'Video',
  VIDEO_THUMB: 'Náhled videa',
  FACES: 'Tváře z videa',
  MESSAGES_TITLE: 'Poznáváte?',
  PERSON: 'osobu',
  OR: 'nebo',
  PLACE: 'místo',
  ON_VIDEO: 'na videu?',
  NAME_PLACEHOLDER: 'Anonymní',
  BTN_SEND: 'Odeslat',
  BTN_PLAY: 'Spustit',
  BTN_SKIP: 'Přeskočit',

  SEND_OVER_TITLE:
    'Abychom mohli  rekonstruovat příběh za filmovými záběry, tak potřebujeme, abyste uvedli kontakt na Vás, který slouží jen pro účely natáčení filmu.',
  SEND_OVER_NAME: 'Jméno (zobrazí se v diskuzi):',
  SEND_OVER_CONTACT: 'Kontakt (pro tvůrce filmu):',
  SEND_OVER_SEND: 'Odeslat',
  SEND_OVER_CANCEL: 'Zrušit odeslání',

  SEND_OVER_OK_TITLE_0: 'Děkujeme za Váš komentář.',
  SEND_OVER_OK_TITLE_1:
    'Byl odeslán tvůrcům filmu, kteří jej po schválení zveřejní v diskuzi.',
  SEND_OVER_OK_CONTINUE: 'Pokračovat',
};



// WEBPACK FOOTER //
// ./src/content.js